export default __webpack_public_path__ + "static/media/correcto.fd183805.png";